import { render, staticRenderFns } from "./MainButton.vue?vue&type=template&id=e9052d02&"
import script from "./MainButton.vue?vue&type=script&lang=js&"
export * from "./MainButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports